import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui } from "@ryde/theme";

const GridNoDataStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "grid-no-data",
})`
  font-size: 24px;
  color: ${blueGreyMui._400};
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-weight: 500;
  letter-spacing: 0.5px;
  opacity: 0;
  animation: fadeInNoData 1.5s ease-out forwards;

  @keyframes fadeInNoData {
    from {
      opacity: 0;
      transform: scale(0.97);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

export const GridNoData: FC = () => {
  const { t } = useTranslation();
  return <GridNoDataStyled>{t("general.NO_ROWS")}</GridNoDataStyled>;
};
